'use strict';

import {callbackOnElements} from '@borngroup/born-utilities';
import {getProductContainer, getPidValue, getOptions} from '../product/productUtils';

export function getTriggerType(triggerEl) {
    return triggerEl.getAttribute('data-wishlist-trigger') || triggerEl.getAttribute('data-wishlist-trigger-ready') || 'cta';
}

/**
 * Multiple items with the same ID might exist on the same page, ensure they're all accounted for.
 * @param  {[type]}  currentID [description]
 * @param  {Boolean} isRemove  [description]
 * @return {[type]}            [description]
 */
export function updateTriggersByID(currentID, isRemove, listIsEmpty) {
    callbackOnElements(`[data-pid="${currentID}"] [data-wishlist-trigger-ready]`, function(currentTrigger) {
        updateTriggerState(currentTrigger, isRemove, listIsEmpty);
    });
}

/**
 * Updates the provided `triggerEl` state to reflect a requested server or event change.
 */
export function updateTriggerState(triggerEl, isRemove, listIsEmpty) {
    let productContainer = getProductContainer(triggerEl),
        triggerType = getTriggerType(triggerEl),
        customLabel = '',
        triggerLabel = '',
        triggerTitle = '',
        isCTA = triggerType === 'cta',
        socialShareEl = document.querySelector('[data-wishlist-component="share"]');

    if (isRemove) {
        triggerEl.classList.remove('set--in-wishlist');
        productContainer.classList.remove('set--in-wishlist');
        productContainer.classList.add('set--removed-wishlist');
        triggerEl.removeAttribute('data-wishlist-remove');

        customLabel = triggerEl.getAttribute('data-wishlist-label-add');

        //These might differ in the future, so keep separate.
        triggerTitle = customLabel || window.SFRA.Resources.wishlistAdd;
        triggerLabel = customLabel || window.SFRA.Resources.wishlistAdd;
    } else {
        triggerEl.classList.add('set--in-wishlist');
        productContainer.classList.add('set--in-wishlist');
        productContainer.classList.remove('set--removed-wishlist');
        triggerEl.setAttribute('data-wishlist-remove', true);

        customLabel = triggerEl.getAttribute('data-wishlist-label-remove');

        triggerTitle = customLabel || window.SFRA.Resources.wishlistRemove;
        triggerLabel = customLabel || window.SFRA.Resources.wishlistRemove;
    }

    triggerEl.title = triggerTitle;

    if (isCTA) {
        let labelTarget = triggerEl.querySelector('[data-wishlist-trigger-component="label"]') || triggerEl;

        labelTarget.textContent = customLabel || triggerLabel;
    }

    if (socialShareEl) {
        if (listIsEmpty) {
            socialShareEl.classList.add('hidden');
        } else {
            socialShareEl.classList.remove('hidden');
        }
    }
}

/**
 * Gets common Wishlist Trigger data such as PID, selected options, etc.
 */
export function getTriggerData(triggerEl) {
    return {
        isRemove: triggerEl.hasAttribute('data-wishlist-remove'),
        pid: getPidValue(triggerEl),
        options: getOptions(triggerEl)[0] || {},
        listValue: triggerEl.getAttribute('data-tracking-context')
    };
}

/**
 * Updates the wishlist triggers for a given container.
 */
export function updateWishlistTriggers(containerEl, isRemove) {
    let wishlistTriggers = containerEl.querySelectorAll('[data-wishlist-trigger-ready]');

    [].forEach.call(wishlistTriggers, currentTrigger => updateTriggerState(currentTrigger, isRemove));
}
